import React from 'react';

// Global Components
// Global Util
// Local Util
// GraphQL Types
// Types
// Queries
// Subcomponents

// Styles
import './_PageTitleId.scss';

// Images

export interface PageTitleIdProps {
  className?: string;
}

export const _PageTitleId: React.FC<PageTitleIdProps> = ( props ) => {
  const { className, children } = props;

  return <span className={ `ops-page-title-id text-muted${className ? ` ${className}` : ''}` }>(ID #{ children })</span>;
};

_PageTitleId.displayName = '_PageTitleId';
